var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeature1Icon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3346 9.9974C18.3346 14.5998 14.6037 18.3307 10.0013 18.3307C5.39893 18.3307 1.66797 14.5998 1.66797 9.9974C1.66797 5.39502 5.39893 1.66406 10.0013 1.66406C14.6037 1.66406 18.3346 5.39502 18.3346 9.9974ZM12.0846 6.8724C12.0846 8.02299 11.1519 8.95573 10.0013 8.95573C8.85071 8.95573 7.91797 8.02299 7.91797 6.8724C7.91797 5.7218 8.85071 4.78906 10.0013 4.78906C11.1519 4.78906 12.0846 5.7218 12.0846 6.8724ZM10.0012 11.0391C7.89963 11.0391 6.08874 12.2838 5.26561 14.0763C6.41175 15.4058 8.10823 16.2474 10.0013 16.2474C11.8943 16.2474 13.5907 15.4058 14.7369 14.0764C13.9138 12.2838 12.1029 11.0391 10.0012 11.0391Z",
    fill: "#23242A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeature1Icon);
export default __webpack_public_path__ + "static/media/feature-1-icon.b2b2bca19d6d3f61685b393748687b52.svg";
export { ForwardRef as ReactComponent };